import React from "react";
import { db } from "./firebase";
import './App.css'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {
  Link
} from "react-router-dom";



class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formValues: {

        servername:""
      },
      formErrors: {           
       servername:""
      },    
 
      formValidity: {
        servername: false
      },
      isSubmitting: false
    };
  }
  addUser = () => {
    const data = {
      ...this.state.formValues,
      uid: new Date().getTime()
    };
    db.collection("instagrampvt")
      .doc(data.uid.toString())
      .set(data)
      .then(() => {
        window.location = "/";
      })
      .catch(error => {
        this.setState({ isSubmitting: false });
      });
  };
  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isSubmitting: true });
    const { formValues, formValidity } = this.state;
    if (Object.values(formValidity).every(Boolean)) {
      this.addUser();
    } else {
      // eslint-disable-next-line no-unused-expressions
      for (let key in formValues) {3
        let target = {
          name: key,
          value: formValues[key]
        };
        this.handleValidation(target);
      };
      this.setState({ isSubmitting: false });
    }
  };
  handleChange = ({ target }) => {
    const { formValues } = this.state;
    formValues[target.name] = target.value;
    this.setState({ formValues });
    this.handleValidation(target);
  };
  handleValidation = target => {
    const { name, value } = target;
    const fieldValidationErrors = this.state.formErrors;
    const validity = this.state.formValidity;
    const isImage = name === "image";
    if (!isImage) {
      validity[name] = value.length > 0;
      fieldValidationErrors[name] = validity[name]
        ? ""
        : `${name} is required and cannot be empty`;
    }
    this.setState({
      formErrors: fieldValidationErrors,
      formValidity: validity
    });
  };
  render() {
    


    const { formValues, formErrors, isSubmitting } = this.state;

    return (
      <div>
<div className="cardii">   	
                <form onSubmit={this.handleSubmit}>
                  <div class="app-form-group">
                    <textarea  class="app-form-control" placeholder=""
                                      type="text"
                                      autocomplete="off"
                                      name="servername"
                                      className={`input ${
                                        formErrors.role ? "is-invalid" : ""
                                      }`}
                                  
                                      onChange={this.handleChange}
                                      value={formValues.servername}
                    />
                  </div>
                  <div class="app-form-group buttons">
               
                    <button   type="submit"  class="app-form-button">Send</button>
                  
        </div>
       
        </form>
        </div>
        </div>
    );
  }
}

export default Register;